import React, { SVGProps } from 'react'

type Direction = 'up' | 'down' | 'left' | 'right'

const rotations: Record<Direction, number> = {
  down: 0,
  left: 90,
  right: 270,
  up: 180,
}

const IconCaret = ({
  style,
  color = 'currentColor',
  direction = 'down',
  open,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'direction'> &
  (
    | { direction?: Direction; open?: never }
    | { direction?: never; open: boolean }
  )) => {
  const dir: Direction =
    open === false ? 'down' : open === true ? 'up' : direction

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 500 400"
      {...props}
      style={{
        transition: 'transform 0.2s ease-in-out',
        ...style,
        transform: `rotate(${rotations[dir]}deg`,
      }}
    >
      <path
        fill={color}
        d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
      />
    </svg>
  )
}

export default IconCaret
